var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shodow"},[_c('div',{staticClass:"loading_content"},[_c('a-spin',{attrs:{"size":"large"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }